<template>
  <div class="left-0 top-0 h-full w-full bg-neutral-900 opacity-75" @click="$emit('close')"></div>
</template>
